<template>
  <div>
    <div class="order-solution">
      <div class="os-list">
        <div class="os-title">
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="left flex-between">
                <div
                  class="title-control flex-between"
                  @click="showHandleData = !showHandleData"
                >
                  <i class="el-icon-arrow-up" v-if="!showHandleData"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                </div>
                <p class="title">
                  {{ $lange == "en" ? "Remark" : "快递运单情况" }}
                </p>
                <span></span>
              </div>
            </el-col>
            <el-col
              :span="12"
              v-if="
                isHandleV2 &&
                (partsListData.status == 4 || partsListData.status == 5)
              "
            >
              <div class="right flex-between">
                <el-button
                  style="width: 150px"
                  type="primary"
                  size="mini"
                  @click="openEditorDialog"
                  >{{
                    $lange == "en" ? "添加快递单号" : "添加快递单号"
                  }}</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>
        <el-collapse-transition>
          <div class="li_wrap" v-if="showHandleData">
            <div
              class="null_remark"
              v-if="partsListDataV2.deliveryList.length == 0"
            >
              无数据
            </div>
            <div
              class="card"
              v-for="(list, index) in partsListDataV2.deliveryList"
            >
              <div class="title_button">
                <div class="title_data">
                  <div>
                    <span>快递单号：{{ list.trackNumber }}</span>
                  </div>
                  <div>
                    <span>处理人：{{ list.adminName }}</span>
                  </div>
                  <div>
                    <span>处理时间：{{ list.createTime }}</span>
                  </div>
                  <div v-if="list.shipStatus == 1">
                    <span v-if="list.isConfirm == 1">状态：已确认收货</span>
                    <span v-if="list.isConfirm == 0">状态：未确认收货</span>
                    <el-button
                      v-if="list.isConfirm == 0"
                      style="width: 100px; margin-left: 10px"
                      type="primary"
                      size="small"
                      @click="confirmDelivery(list)"
                      >代客户确认</el-button
                    >
                  </div>
                </div>
                <div
                  v-if="list.shipStatus == 0"
                  style="min-width: 311px; margin-left: 30px"
                >
                  <el-button
                    style="width: 150px"
                    type="danger"
                    size="small"
                    @click="deleteDelivery(list)"
                    >{{ $lange == "en" ? "Delete" : "删除" }}</el-button
                  >
                  <el-button
                    style="width: 150px"
                    type="primary"
                    size="small"
                    @click="sendPartsMsg(list)"
                    >{{
                      $lange == "en"
                        ? "Confirm and send product information"
                        : "确认并发送货品信息"
                    }}</el-button
                  >
                </div>
              </div>
              <div class="centen">
                <div class="centen_left">
                  <div class="centen_left_button">
                    <h4 style="margin-right: 10px">配送的配件明细</h4>
                    <el-button
                      style="width: 150px"
                      v-if="partsListData.status <= 5 && list.shipStatus == 0"
                      size="mini"
                      icon="el-icon-plus"
                      @click="addPartsList(list)"
                      >添加配件</el-button
                    >
                  </div>
                  <cc-table
                    :config="tableConfig"
                    :data-arr="list.deliveryLogList"
                    :load-data="false"
                  ></cc-table>
                </div>
                <div class="centen_right">
                  <div class="centen_left_button">
                    <h4 style="margin-right: 10px">快递凭证</h4>
                    <el-button
                      v-if="partsListData.status <= 5 && list.shipStatus == 0"
                      size="mini"
                      icon="el-icon-plus"
                      @click="openUploaderDialog(index)"
                      >上传凭证</el-button
                    >
                  </div>
                  <div class="file_img">
                    <div v-if="list.trackProofUrlList.length == 0">无</div>
                    <div
                      class="img_list"
                      v-for="(img, ind) in list.trackProofUrlList"
                      :key="ind"
                    >
                      <el-image
                        :key="index"
                        class="img"
                        :src="img"
                        fit="fit"
                        @click="showImage(img)"
                      >
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i></div
                      ></el-image>
                      <div
                        class="del-image flex-between"
                        @click.stop="deleteImage(index, ind)"
                        v-if="partsListData.status <= 5 && list.shipStatus == 0"
                      >
                        X
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <el-dialog
      :title="netNum == 1 ? '添加快递单号' : '添加配送的配件'"
      :visible.sync="editorDialog"
      width="50%"
      append-to-body
    >
      <template v-if="editorDialog">
        <el-form
          ref="addDeliveryForm"
          :model="addDeliveryForm"
          size="mini"
          label-width="100px"
          :rules="rules"
          v-if="netNum == 1"
        >
          <el-form-item
            prop="trackNumber"
            :label="$lange == 'en' ? 'Courier number:' : '快递单号:'"
          >
            <el-input v-model="addDeliveryForm.trackNumber"></el-input>
          </el-form-item>
          <el-form-item
            :label="$lange == 'en' ? 'Express voucher:' : '快递凭证:'"
            prop="trackProofUrl"
          >
            <cc-uploader
              :config="uploaderConf2"
              v-model="addDeliveryForm.trackProofUrl"
            />
          </el-form-item>
          <div class="cancelRemark_btn">
            <el-button size="small" @click="editorDialog = false"
              >取消</el-button
            >
            <el-button type="primary" size="small" @click="addDeliveryFun"
              >下一步</el-button
            >
          </div>
        </el-form>

        <el-form
          :model="addDeliveryForm"
          size="mini"
          label-width="100px"
          v-if="netNum == 2"
        >
          <el-form-item
            prop="trackNumber"
            :label="$lange == 'en' ? 'Courier number' : '快递单号:'"
          >
            <el-input v-model="addDeliveryForm.trackNumber" disabled></el-input>
          </el-form-item>

          <div class="centent_list_title">添加配件及发货数量:</div>
          <div class="centent_list" v-for="(delivery, index) in unDeliveryList">
            <div style="width: 50%">
              {{ delivery.partsName }}
              <span>(待配送数量：{{ delivery.unDeliveryNum }})</span>
            </div>
            <div>
              数量
              <el-input-number
                v-model="delivery.inputNum"
                :min="0"
                :max="delivery.unDeliveryNum"
                size="mini"
                :disabled="delivery.unDeliveryNum == 0 ? true : false"
              ></el-input-number>
            </div>
          </div>
          <div class="cancelRemark_btn">
            <el-button size="small" @click="editorDialog = false"
              >取消</el-button
            >
            <el-button type="primary" size="small" @click="addDeliveryFun2"
              >确认</el-button
            >
          </div>
        </el-form>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="showImageFlag" width="80%" append-to-body>
      <img
        :src="nowShowImageUrl"
        style="display: block; margin: 0 auto; width: 100%"
        alt
      />
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? 'Upload attachments' : '上传附件'"
      :visible.sync="uploaderDialog"
      width="30%"
      append-to-body
    >
      <template v-if="uploaderDialog">
        <div class="uploader">
          <cc-uploader
            :config="uploaderConf2"
            uploadType="dottedLine"
            @upload-success="uploadTrue"
            :isMultiple="false"
          />
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    partsListData: Object,
    isHandleV2: Boolean,
  },
  data() {
    return {
      showImageFlag: false,
      nowShowImageUrl: "",
      showHandleData: true,
      editorDialog: false,
      uploaderDialog: false,
      uploaderConf2: this.$uploadUtils.config,
      addDeliveryForm: {
        // trackNumber: "",
        // trackProofUrl: "",
      },
      rules: {
        trackNumber: [
          { required: true, message: "请输入快递单号", trigger: "blur" },
        ],
        trackProofUrl: [
          { required: true, message: "请上传快递凭证", trigger: "blur" },
        ],
      },
      netNum: 1,
      tableConfig: {
        columns: [
          {
            prop: "parts.partsDescription",
            lable: this.$lange == "en" ? "商品名称" : "商品名称",
            minWidth: 150,
            render: (rows) => {
              if (rows.parts) {
                return rows.parts.partsName;
              }
            },
          },
          {
            prop: "deliveryNum",
            lable: this.$lange == "en" ? "Quantity" : "数量",
            minWidth: 100,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Modification" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Delete" : "删除",
            click: (row, index) => {
              this.$confirm("此操作会从该记录中删除该配件, 是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                let data = {
                  id: row.id,
                };
                this.ccRequest
                  .do("admin/fsb/delivery/log/delete", data, "GET")
                  .then((res) => {
                    this.$emit("updateOrder", true);
                    this.$message({
                      type: "success",
                      message: "删除成功",
                    });
                    this.getPartsList();
                  });
              });
            },
            check: (rows) => {
              return this.partsListData.status <= 5 && rows.shipStatus == 0
                ? true
                : false;
            },
          },
        ],
      },
      unDeliveryList: [],
      index: -1,
      partsListDataV2: {},
    };
  },
  watch: {
    partsListData: {
      handler() {
        let partsListDataV2 = { ...this.partsListData };
        // for (
        //   let index = 0;
        //   index < partsListDataV2.deliveryList.length;
        //   index++
        // ) {
        //   if (partsListDataV2.deliveryList[index].trackProofUrl) {
        //     partsListDataV2.deliveryList[index].trackProofUrlArr =
        //       partsListDataV2.deliveryList[index].trackProofUrl.split(",");
        //   } else {
        //     partsListDataV2.deliveryList[index].trackProofUrlArr = [];
        //   }
        // }
        this.partsListDataV2 = partsListDataV2;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openEditorDialog() {
      this.ccRequest
        .do(
          "admin/fsb/delivery/queryUnDeliveryNum",
          { partsOrderId: this.partsListDataV2.id },
          "GET"
        )
        .then((res) => {
          this.unDeliveryList = res;
          this.netNum = 1;
          this.editorDialog = true;
          this.addDeliveryForm = {};
          this.$emit("updateOrder", true);
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    addPartsList(list) {
      this.ccRequest
        .do(
          "admin/fsb/delivery/queryUnDeliveryNum",
          { partsOrderId: this.partsListDataV2.id },
          "GET"
        )
        .then((res) => {
          this.unDeliveryList = res;
          this.netNum = 2;
          this.editorDialog = true;
          this.addDeliveryForm = { ...list };
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    addDeliveryFun() {
      this.$refs["addDeliveryForm"].validate((valid) => {
        if (valid) {
          let data = this.addDeliveryForm;
          data.partsOrderId = this.partsListDataV2.id;
          this.ccRequest
            .do("admin/fsb/delivery/save", data, "POSTJSON")
            .then((res) => {
              this.netNum = 2;
              this.addDeliveryForm = res;
              this.$emit("updateOrder", true);
              //   this.$message({
              //     type: "success",
              //     message: "保存成功",
              //   });
            })
            .catch((res) => {
              this.$message({
                type: "error",
                message: res.response.data.message,
              });
            });
        } else {
          return false;
        }
      });
    },

    addDeliveryFun2() {
      console.log(this.unDeliveryList, this.addDeliveryForm);
      let type = true;
      let from = {
        deliveryId: this.addDeliveryForm.id,
        deliveryNumList: [],
      };
      for (let index = 0; index < this.unDeliveryList.length; index++) {
        if (this.unDeliveryList[index].inputNum) {
          type = false;
          from.deliveryNumList.push({
            partsOrderLogId: this.unDeliveryList[index].partsOrderLogId,
            deliveryNum: this.unDeliveryList[index].inputNum,
          });
        }
      }
      if (type) {
        this.$message({
          type: "error",
          message: "最少添加一种配件",
        });
        return false;
      }
      console.log(from);

      this.ccRequest
        .do("admin/fsb/delivery/log/batchSave", from, "POSTJSON")
        .then((res) => {
          this.editorDialog = false;
          this.$emit("updateOrder", true);
        })
        .catch((res) => {
          console.log(res);
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    showImage(url) {
      this.nowShowImageUrl = url;
      this.showImageFlag = true;
    },
    openUploaderDialog(index) {
      this.uploaderDialog = true;
      this.index = index;
    },
    uploadTrue(res) {
      this.partsListDataV2.deliveryList[this.index].trackProofUrlList.push(res);

      let data = {};
      data.trackProofUrl =
        this.partsListDataV2.deliveryList[this.index].trackProofUrlList.join(
          ","
        );
      data.id = this.partsListDataV2.deliveryList[this.index].id;
      console.log(data, 11111);
      this.ccRequest
        .do("admin/fsb/delivery/updateTrackProofUrl", data, "POSTJSON")
        .then((res) => {
          this.uploaderDialog = false;
          this.$emit("updateOrder", true);
          this.$message({
            type: "success",
            message: "上传成功",
          });
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    deleteImage(index, idx) {
      let partsListDataV2 = { ...this.partsListDataV2 };
      partsListDataV2.deliveryList[index].trackProofUrlList.splice(idx, 1);
      this.partsListDataV2 = partsListDataV2;

      let data = {};
      data.trackProofUrl =
        this.partsListDataV2.deliveryList[index].trackProofUrlList.join(",");
      data.id = this.partsListDataV2.deliveryList[index].id;
      this.ccRequest
        .do("admin/fsb/delivery/updateTrackProofUrl", data, "POSTJSON")
        .then((res) => {
          this.$message({
            type: "success",
            message: "保存成功",
          });
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },

    sendPartsMsg(item) {
      if (item.deliveryLogList.length < 1) {
        return this.$message({
          type: "warning",
          message: "该快递单没有配件需要发送",
        });
      }
      let data = {
        deliveryId: item.id,
        // id: item.id,
        // shipStatus: 1,
        // workOrderId: this.partsListData.workOrderId,
      };
      this.$confirm("你当前的操作会给客户推送通知", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/delivery/confirmGoods", data, "GET")
            .then((res) => {
              this.$emit("updateOrder", true);
              this.$message({
                type: "success",
                message: "发送成功",
              });
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    deleteDelivery(item) {
      this.$confirm("此操作会删除快递单号及整条配送记录, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          id: item.id,
        };
        this.ccRequest
          .do("admin/fsb/delivery/delete", data, "GET")
          .then((res) => {
            this.$emit("updateOrder", true);

            this.$message({
              type: "success",
              message: "删除成功",
            });
          });
      });
    },
    confirmDelivery(item) {
      this.$confirm("此操作将确认收货, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          deliveryId: item.id,
        };
        this.ccRequest
          .do("admin/fsb/delivery/isConfirmDelivery", data, "GET")
          .then((res) => {
            this.$emit("updateOrder", true);
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.order-solution {
  background: #ffffff;
  // margin-top: 5px;

  .os-list {
    padding: 20px;
    // border-bottom: 1px dotted #ccc;
    border-bottom: 10px solid #f3f3f4;
    // border-top: 10px solid #ebebeb;
    .os-title {
      .left {
        justify-content: flex-start;

        > * {
          margin-left: 80px;
        }

        .title-control {
          padding: 0px;
          border-radius: 5px;
          border: 1px solid #e4e4e4;
          width: 24px;
          height: 24px;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
          margin-left: 0;
          & ~ .title {
            font-weight: bolder;
            color: #6f6f6f;
            width: 200px;
          }
        }

        .title {
          font-size: 18px;
          margin-left: 20px;
        }
      }
    }
  }
}
.li_wrap {
  margin-top: 20px;
  .li {
    margin-bottom: 20px;
  }
}
.right {
  display: flex;
  justify-content: flex-end;
}
.add_remark_button {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.title_wrap {
  display: flex;
  color: #000;
  .title {
    margin-right: 10px;
  }
}
.null_remark {
  text-align: center;
  padding: 10px;
  color: #c3c1c1;
  font-size: 16px;
}

.cancelRemark_btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.title_button {
  display: flex;
  justify-content: space-between;
  .title_data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 76%;
    font-weight: 700;
  }
}
.card {
  padding: 20px;
  background: #f5f7fa;
  border-radius: 5px;
}
.centen {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 20px;
  .centen_left,
  .centen_right {
    width: 45%;
  }
  .centen_left_button {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  h3 {
    margin-right: 10px;
  }
}
.centent_list_title {
  margin: 10px 0;
  padding-left: 30px;
  font-size: 14px;
  font-weight: bold;
}
.centent_list {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding-left: 30px;
  width: 100%;
  span {
    color: #c3031b;
    margin: 0 40px 0 20px;
  }
}

.file {
  margin-top: 20px;
  display: flex;
  padding-bottom: 30px;
}
.file_img {
  display: flex;
  .img_list {
    position: relative;
  }
  .img {
    width: 80px;
    height: 80px;
    margin: 0 10px;
  }
  .del-image {
    width: 20px;
    height: 20px;
    line-height: 0;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    border: 1px solid #f00;
    color: #f00;
    font-size: 14px;
    border-radius: 50%;
    transform: translateX(0%) translateY(-50%);
    cursor: pointer;
  }
}

.uploader {
  position: relative;
  height: 200px;
}
</style>

<style lang="scss">
.image-slot {
  width: 100%;
  height: 100%;
  background: #dbdddf;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style> 